import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DevToolsService {
    liveStateDebug = new BehaviorSubject<string | null>(null);
    liveStateDebugProps = new BehaviorSubject<any>(null);
    liveStateDebugActivatedAt?: Date;
}
